import React from 'react'
import { HospitalFormSchema } from '../../schemas/HospitalFormSchema'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, InputLabel } from '@mui/material';
import InputController from '../../components/InputController/InputController';
import { FormContainer, SubmitWrapper } from './HospitalStyle';
import useToast from '../../hooks/useToast';
import CustomToast from '../../components/Toast/CustomToast';

const AddHospital = () => {
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const { handleSubmit,  reset, control, formState: {errors, isValid, isDirty} } = useForm({
    resolver: yupResolver(HospitalFormSchema),
    mode: "onChange",
    defaultValues:{
      hospital_name: "",
      hospital_email: "",
      password: "",
      hospital_contact: "",
      hospital_region: "",
      hospital_contact_person_name: "",
      hospital_address: "",
      hospital_zio_code: "",
    }
  });

  const onSubmit = (data)=>{
    // reset();
    showToast("success", "Hospital Added Successfully")
  }

  return (
    <>
    <form onSubmit={handleSubmit(onSubmit)}>
                <InputLabel sx={{fontSize: "1.5rem"}}>Add Hospital</InputLabel>
                <FormContainer>
                   <InputController
                     name="hospital_name"
                     label="Hospital Name"
                     control={control}
                     errors={errors}/>

                     <InputController
                     name="hospital_email"
                     label="Hospital Email"
                     control={control}
                     errors={errors}/>

                    <InputController
                     name="password"
                     label="Password"
                     control={control}
                     errors={errors}/>

                     <InputController
                     name="hospital_contact"
                     label="Hospital Contact"
                     control={control}
                     errors={errors}/>
                     
                     <InputController
                     name="hospital_region"
                     label="Hospital Region"
                     control={control}
                     errors={errors}/>

                     <InputController
                     name="hospital_contact_person_name"
                     label="Hospital Contact Person Name"
                     control={control}
                     errors={errors}/>

                     <InputController
                     name="hospital_address"
                     label="Hospital Address"
                     control={control}
                     errors={errors}/>

                     <InputController
                     name="hospital_zio_code"
                     label="Hospital Zip Code"
                     control={control}
                     errors={errors}/>
             </FormContainer>
            <SubmitWrapper>
                <Button type="submit" variant="contained"
                  sx={{minWidth:"180px"}}
                  disabled={!isValid || !isDirty}>Add</Button>
                   <Button type="button" variant="contained" onClick={()=>reset()}
                   sx={{minWidth:"180px"}}>Reset</Button>
            </SubmitWrapper>
    </form>

     {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}

    </>
  )
}

export default AddHospital